export default __webpack_public_path__ + "static/media/starofthesea.fa72c76f.jpg";